(function () {
  var banner = document.getElementById('cran-cookie-consent');
  if (!banner) return;

  var status = banner.querySelector('[data-cran-consent-status]');
  var privacyApi = null;

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  function showBanner() {
    setStatus('');
    banner.hidden = false;
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function dispatchConsent(granted) {
    document.dispatchEvent(new CustomEvent('cran:consent', {
      detail: {
        status: granted ? 'accepted' : 'refused',
        analytics: granted,
        marketing: granted,
        preferences: granted
      }
    }));
  }

  function loadPrivacyApi(callback) {
    if (privacyApi) {
      callback(null, privacyApi);
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback(new Error('API de confidentialité Shopify indisponible'));
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          callback(error || new Error('API de confidentialité Shopify indisponible'));
          return;
        }
        privacyApi = window.Shopify.customerPrivacy;
        callback(null, privacyApi);
      }
    );
  }

  loadPrivacyApi(function (error, api) {
    if (error) {
      showBanner();
      return;
    }
    if (typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) {
      showBanner();
    }
  });

  document.addEventListener('click', function (event) {
    var preferencesButton = event.target.closest('a[href="#cran-cookie-consent"], [data-cran-cookie-preferences]');
    if (preferencesButton) {
      event.preventDefault();
      showBanner();
      return;
    }

    var button = event.target.closest('[data-cran-consent]');
    if (!button || !banner.contains(button)) return;

    var granted = button.getAttribute('data-cran-consent') === 'accept';
    setStatus('Enregistrement de votre choix…');
    button.disabled = true;

    loadPrivacyApi(function (error, api) {
      if (error) {
        button.disabled = false;
        setStatus('Impossible d’enregistrer ce choix. Réessayez dans un instant.');
        return;
      }

      api.setTrackingConsent(
        {
          preferences: granted,
          analytics: granted,
          marketing: granted
        },
        function () {
          button.disabled = false;
          dispatchConsent(granted);
          hideBanner();
        }
      );
    });
  });

  document.addEventListener('visitorConsentCollected', function (event) {
    document.dispatchEvent(new CustomEvent('cran:consent', { detail: event.detail || {} }));
  });
})();
